import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { calendarQuery } from '@app/pcs/data/calendar.queries';

@Injectable()
export class CalendarRestService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetchCalendar(id, validityPeriod) {
    return this.graphqlService.query(calendarQuery, {
      id,
      validityPeriod
    }, hideLoader());
  }
}
